<fury-page-layout mode="card">
    <fury-page-layout-header>
        <div class="top_heading">
            <fury-breadcrumbs current="View Agreement"></fury-breadcrumbs>
            <button mat-button class="can-button" (click)="redirectToAgreementList()"><mat-icon>keyboard_backspace</mat-icon> Back</button>
        </div>
    </fury-page-layout-header>
    <fury-page-layout-content [@fadeInUp]>
        <div class="two_section">
            <div class="righpanel">
                <div class="view_panel">
                    <h2>
                        View agreement
                    </h2>
                    <div *ngIf="!isLoading" class="claim_showprt">
                        <div class="claim_inputprt">
                            <label>
                                Policy No.
                            </label>
                            <p>
                                {{ agreementDetails?.agreementNumber }}
                            </p>
                        </div>
                        <div class="claim_inputprt">
                            <label>
                                Status
                            </label>
                            <p>
                                {{ agreementDetails?.status }}
                            </p>
                        </div>
                        <div class="claim_inputprt">
                            <label>
                                Full Name
                            </label>
                            <p>
                                {{ commonService.getFullName(agreementDetails?.firstName, agreementDetails?.lastName) }}
                            </p>
                        </div>
                        <div class="claim_inputprt">
                            <label>
                                Address
                            </label>
                            <p>
                                {{ agreementDetails?.billingAddress?.streetAddress }}
                            </p>
                        </div>
                        <div class="claim_inputprt">
                            <label>
                                City
                            </label>
                            <p>
                                {{ agreementDetails?.billingAddress?.city }}
                            </p>
                        </div>
                        <div class="claim_inputprt">
                            <label>
                                State
                            </label>
                            <p>
                                {{ agreementDetails?.billingAddress?.state }}
                            </p>
                        </div>
                        <div class="claim_inputprt">
                            <label>
                                Zip Code
                            </label>
                            <p>
                                {{ agreementDetails?.billingAddress?.zip }}
                            </p>
                        </div>
                        <div class="claim_inputprt">
                            <label>
                                Phone
                            </label>
                            <p>
                                {{ agreementDetails?.phoneNumber | mask: '(000) 000-0000' }}
                            </p>
                        </div>
                        <div class="claim_inputprt">
                            <label>
                                Email
                            </label>
                            <p>
                                {{ agreementDetails?.emailAddress }}
                            </p>
                        </div>
                        <div class="claim_inputprt">
                            <label>
                                Lead Source
                            </label>
                            <p>
                                {{ agreementDetails?.leadSource }}
                            </p>
                        </div>
                        <div class="claim_inputprt">
                            <label>
                                Plan Type
                            </label>
                            <p>
                                {{ agreementDetails?.orderPlanDetail?.orderMainPlanDetails?.plan_optional_item_category?.title }}
                            </p>
                        </div>
                        <div class="claim_inputprt">
                            <label>
                                Property Type
                            </label>
                            <p>
                                {{ agreementDetails?.orderPlanDetail?.orderPropertyTypeName }}
                            </p>
                        </div>
                        <div class="claim_inputprt">
                            <label>
                                Property Size
                            </label>
                            <p>
                                {{ agreementDetails?.orderPlanDetail?.orderPropertySizeName }}
                            </p>
                        </div>
                        <div class="claim_inputprt">
                            <label>
                                Term
                            </label>
                            <p>
                                {{ agreementDetails?.agreementExpireDate ===  null ? agreementDetails?.agreementEffectiveDate + ' - Ongoing' : agreementDetails?.agreementEffectiveDate + ' - '+ agreementDetails?.agreementExpireDate }}
                            </p>
                        </div>
                        <div class="claim_inputprt">
                            <label>
                                Price
                            </label>
                            <p>
                               {{agreementDetails?.subTotalCost | currency}}
                            </p>
                        </div>
                        <div class="claim_inputprt">
                            <label>
                                Paid
                            </label>
                            <p>
                                {{agreementDetails?.downPaymentAmount | currency}}
                            </p>
                        </div>
                        <div class="claim_inputprt">
                            <label>
                                Balance
                            </label>
                            <p>
                                {{ formatCurrency(agreementDetails?.subTotalCost - agreementDetails?.downPaymentAmount) }}
                            </p>
                        </div>
                        <div class="claim_inputprt">
                            <label>
                                Waiting Period
                            </label>
                            <p>
                                {{ getWaitingPeriod(agreementDetails?.waitingPeriod) }}
                            </p>
                        </div>
                        <div class="claim_inputprt">
                            <label>
                                Effective Date
                            </label>
                            <p>
                                {{ commonService.convertDate(agreementDetails?.agreementEffectiveDate) | date : "MMM-dd-YYYY" }}
                            </p>
                        </div>
                        <div class="claim_inputprt">
                            <label>
                                Copay
                            </label>
                            <p>
                                {{ formatCurrency(agreementDetails?.copayFee) }}
                            </p>
                        </div>
                        <div class="claim_inputprt">
                            <label>
                                surcharge
                            </label>
                            <p>
                                {{ formatCurrency(agreementDetails?.surchargeAmount) }}
                            </p>
                        </div>
                        <div class="claim_inputprt">
                            <label>
                                Creation Date
                            </label>
                            <p>
                                {{ commonService.convertDate(agreementDetails?.agreementPurchaseDate) | date : "MMM-dd-YYYY" }}
                            </p>
                        </div>
                        <div class="claim_inputprt">
                            <label>
                                Created By
                            </label>
                            <p>
                                {{ commonService.getFullName(agreementDetails?.agentDetail?.firstName, agreementDetails?.agentDetail?.lastName) }}
                            </p>
                        </div>
                        
                    </div>
                    <div *ngIf="isLoading" style="text-align: center;">Please wait...</div>
                </div>
            </div>
        </div>
    </fury-page-layout-content>
</fury-page-layout>